import React, { useEffect } from "react";
import { Form, Input, Space } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getClientUserDetails, 
	doClientUserCreate, 
	doClientUserUpdate,  
} from "../../../../../redux/client/clientState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField, emailField } from "utils/crudSagaHelper";
import SwitchField from "components/fields/SwitchField";

const ClientUserForm = ({
	doCreate, 
	doUpdate, 
	onCancel, 
	recordData,
	clientId,
	getDetails,
	submitLabel,
	recordId,
	mode,
	...props
 }) => {
		
  	const [form] = Form.useForm();
	
	useEffect(() => {	
		if (recordData) {
			form.resetFields();
			const {user, ...rest} = recordData;
			const { user_detail, ...restUser } = user;
			const initialValues = {
				...rest,
				...restUser,
				...user_detail,
				clu_client_id: clientId,
			};
			console.log(initialValues);
			form.setFieldsValue(initialValues);
		}
	}, [recordData, clientId, form]);

	useEffect(() => {
		if (clientId) {
			getDetails({ clientId, recordId});
		}
	}, [clientId, recordId, getDetails]);
   
  	const onSubmit = (formData) => {
		try { 
			recordData?.clu_id > 0 ? doUpdate(formData): doCreate(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
	};
  
  	return (
		<Form className={mode !== "view" ? "form" : ""}
			layout="vertical"
			form={form}
			onFinish={onSubmit}
		>   
			<FormItem
				name="clu_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<FormItem
				name="clu_user_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<FormItem
				name="clu_client_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="form-column-2">
				<Space.Compact className="font-medium gap-2 w-full">
					<FormItem 
						label="First Name"
						name="ude_first_name"
						rules={[requiredField]}
						className="mb-0 w-1/2"
					>
						{mode !== "view" ?
							<Input id="ude_first_name"
								placeholder="First Name" 
								className="input-field" 
								maxLength={50}
							/>
							: 
							<span className="text-base label-value dark:text-white">
								{recordData?.user?.user_detail?.ude_first_name}
							</span>
						}
					</FormItem>
					<FormItem 
						label="Last Name"
						name="ude_last_name"
						rules={[requiredField]}
						className="mb-0 w-1/2"
					>
						{mode !== "view" ?
							<Input id="ude_last_name"
								placeholder="Last Name" 
								className="input-field" 
								maxLength={50}
							/>
							: 
							<span className="text-base label-value dark:text-white">
								{recordData?.user?.user_detail?.ude_last_name}
							</span>
						}
					</FormItem>
				</Space.Compact>
				<FormItem 
					label="Email"
					name="email"
					rules={[requiredField, emailField]}
				>
					{mode !== "view" ?
						<Input id="email"
							placeholder="username@domain.com" 
							className="input-field" 
							maxLength={50}
						/>
						: 
						<span className="text-base label-value dark:text-white">
							{recordData?.user?.email}
						</span>
					}
				</FormItem>
				<FormItem 
					label="Role / Job Title"
					name="clu_job_title"
				>
					{mode !== "view" ?
						<Input id="clu_job_title"
							className="input-field" 
							maxLength={50}
						/>
						: 
						<span className="text-base label-value dark:text-white">
							{recordData?.clu_job_title}
						</span>
					}
				</FormItem>
				{(mode === "edit" && !recordData?.clu_id > 0) && (
					<FormItem 
						label="Send Account Notification"
						name="send_notification"
					>
						<SwitchField
							id="send_notification"
							mode="edit"
							type="text"
							labelYes="Yes"
							labelNo="No"
						/>
					</FormItem>
 				)}
			</div>
			<div className="w-full flex justify-end dark:">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.clu_id ?? 0}
						isModal={true}
						modalId={recordData?.clu_id > 0 ? 'edit_client_user' : 'add_client_user'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
					/>
				)}
			</div>
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.client.clientUserDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getDetails: (data) => dispatch(getClientUserDetails(data)),
  	doCreate: (data) => dispatch(doClientUserCreate(data)),
  	doUpdate: (data) => dispatch(doClientUserUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientUserForm);
